import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link DismissActionBarCommand}
 */
export type DismissActionBarCommandProperties = CommandProperties;

/**
 * Command to dismiss/hide the database action bar in the native embed experience.
 *
 * This command removes the action bar from view, typically called when users
 * deselect entries or click elsewhere in the database interface.
 *
 * @see {@link ShowActionBarCommand}
 */
export const DismissActionBarCommand = createCommand<
  DismissActionBarCommandProperties,
  void
>('dismiss-action-bar-command');
